// Component
export default () => {
    const sections = document
        .querySelectorAll('.featured-press-list')

    // If there are no sections, return
    if (!sections.length)
        return

    const uriQuery = (values) => Object.keys(values)
        .filter(key => values[key] !== '')
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(values[key])}`)
        .join('&')

    const paramFrom = (name) => {
        const match = new RegExp(`[?&]${name}=([^&]*)`)
            .exec(window.location.search)

        return match
            ? decodeURIComponent(match[1].replace(/\+/g, ' '))
            : ''
    }

    // Only used when the endpoint is missing and the form submits natively.
    const prune = (form) => {
        Array.from(form.elements)
            .forEach(el => {
                if (el.name
                        && el.value === '')
                    el.disabled = true
            })
    }

    sections.forEach(section => {
        const perPage = parseInt(section.dataset.perPage, 10)
            || 6

        const endpoint = section.dataset.endpoint

        const list = section
            .querySelector('.featured-press-list-items')

        if (!list)
            return

        const form = section
            .querySelector('.featured-press-list-filters')

        let page = Math.max(1, parseInt(paramFrom('press_page'), 10) || 1)
        let controller = null

        const nav = () => section
            .querySelector('.featured-press-list-pagination')

        const field = (name) => {
            const el = form && form.querySelector(`[name="${name}"]`)

            return el
                ? el.value
                : ''
        }

        // page one is the default, stays out of the url
        const currentQuery = () => {
            const values = {
                press_category: field('press_category'),
                press_s: field('press_s')
            }

            if (page > 1)
                values.press_page = page

            return uriQuery(values)
        }

        const swapNav = (markup) => {
            const existing = nav()

            if (existing)
                existing.remove()

            if (markup
                    && markup.trim())
                list.insertAdjacentHTML('afterend',
                    markup)
        }

        const load = (push, scroll) => {
            const query = currentQuery()

            controller
                && controller.abort()

            controller = 'AbortController' in window
                ? new AbortController()
                : null

            list.setAttribute('aria-busy',
                'true')

            const url = `${endpoint}?per_page=${encodeURIComponent(perPage)}`
                + `&id=${encodeURIComponent(section.id)}`
                + `&page=${encodeURIComponent(page)}`
                + `&base=${encodeURIComponent(window.location.pathname)}`
                + (section.dataset.items
                    ? `&items=${encodeURIComponent(section.dataset.items)}`
                    : '')
                + (query
                    ? `&${query}`
                    : '')

            window.fetch(url, controller
                ? { signal: controller.signal }
                : {})
                .then(res => res.json())
                .then(data => {
                    list.innerHTML = data.html

                    swapNav(data.pagination)

                    list.setAttribute('aria-busy',
                        'false')

                    window.objectFitPolyfill
                        && window.objectFitPolyfill()

                    if (push)
                        window.history.pushState({}, '',
                            window.location.pathname
                                + (query
                                    ? `?${query}`
                                    : ''))

                    if (scroll)
                        section.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        })
                })
                .catch(() => {
                    list.setAttribute('aria-busy', 'false')
                })
        }

        // pagination markup swapped in wired by fetch.
        section.addEventListener('click', (ev) => {
            const link = ev.target.closest
                && ev.target.closest('.featured-press-list-pagination [data-page]')

            if (!link
                    || !endpoint)
                return

            ev.preventDefault()

            if (link.getAttribute('aria-disabled') === 'true')
                return

            const target = parseInt(link.dataset.page, 10)

            if (!target
                    || target === page)
                return

            page = target

            load(true, true)
        })

        if (form) {
            form.addEventListener('submit', (ev) => {
                // no endpoint means no enhancement: let it submit for real.
                if (!endpoint) {
                    prune(form)

                    return
                }

                ev.preventDefault()

                // a new filter starts from first page.
                page = 1

                load(true, true)
            })

            const category = form
                .querySelector('.featured-press-list-filters-category')

            category
                && category.addEventListener('change', () => {
                    if (!endpoint) {
                        prune(form)

                        form.submit()

                        return
                    }

                    page = 1

                    load(true, true)
                })

            window.addEventListener('popstate', () => {
                if (!endpoint)
                    return

                const input = form
                    .querySelector('[name="press_s"]')

                if (input)
                    input.value = paramFrom('press_s')

                if (category)
                    category.value = paramFrom('press_category')

                page = Math.max(1, parseInt(paramFrom('press_page'), 10) || 1)

                load(false, false)
            })
        }
    })

    // A direct hit on a filtered URL is server-rendered,
    // so land on the component the same way paging does.
    if (!/[?&](press_s|press_category|press_page)=[^&]/.test(window.location.search))
        return

    sections.forEach(section => {
        if (section.querySelector('.featured-press-list-filters'))
            section.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            })
    })
}
